<template>
  <div class="content-section" v-loading="loadingFull"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="header">
      <h1>留言板</h1>
      <p>案件编号：{{caseId}}</p>
    </div>

    <div class="container">
      <section v-if="ParentUserId == AccountId" class="new-message-section">
        <h2 class="section-title"><i class="fa fa-pencil-square-o"></i> 发表新留言</h2>
        <form v-model="form">
          <div class="form-group">
            <label for="message"><i class="fa fa-comment"></i> 留言内容</label>
            <textarea id="message" v-model="form.F_Message" placeholder="请输入留言内容..." required></textarea>
          </div>
        </form>
        <button class="btn" @click="sendMessage"><i class="fa fa-paper-plane"></i> 发布留言</button>
      </section>

      <section class="messages-section">
        <h2 class="section-title"><i class="fa fa-list"></i> 所有留言</h2>
        <div class="message-count">目前共有 <span id="messageCount">{{messages?messages.length:0}}</span> 条留言</div>
        <div id="messagesContainer">
          <!-- 留言将通过JavaScript动态加载 -->
          <div v-if="messages && messages.length>0" class="message" v-for="(item,index) in messages" :key="index">
            <div class="message-header">
              <div class="message-author"><i class="fa fa-user"></i> {{item.F_Creator}}</div>
              <div class="message-time"><i class="fa fa-clock-o"></i> {{item.F_CreateTime}}</div>
            </div>
            <div class="message-content">{{item.F_Message}}</div>
            <div v-if="ParentUserId == AccountId" class="message-actions">
              <button class="btn btn-reply" @click="toggleFun(item)">
                <i class="fa fa-reply"></i> 回复
              </button>
            </div>
            <div v-if="item.F_Show" class="reply-form">
              <!--<div class="form-group">-->
                <!--<input type="text" id="reply-author-1" placeholder="请输入您的姓名" required="">-->
              <!--</div>-->
              <div class="form-group">
                <textarea v-model="item.F_ReMessage" placeholder="请输入回复内容..." required=""></textarea>
              </div>
              <button class="btn btn-reply" @click="reCall(item)">
                <i class="fa fa-paper-plane"></i> 提交回复
              </button>
            </div>
            <div v-if="item.F_Replies && item.F_Replies.length>0" class="replies">
              <div class="reply" v-for="(it,jndex) in item.F_Replies" :key="jndex">
                <div class="reply-header">
                  <div class="reply-author"><i class="fa fa-user"></i> {{it.F_Creator}}</div>
                  <div class="reply-time"><i class="fa fa-clock-o"></i> {{it.F_CreateTime}}</div>
                </div>
                <div class="reply-content">{{it.F_Message}}</div>
              </div>
            </div>
          </div>
          <div v-else class="no-messages">
            <i class="fa fa-comments-o"></i>
            <p>还没有留言，成为第一个留言的人吧！</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        caseId:'',
        form: {
          F_CaseId:'',
          F_ParentId:0,
          F_Message:'',
          F_Type:1,
        },
        messages:[],
        show:false,
        url: {
          list: SZH.assets.api + '/Custom/GetCaseMessageBoard',
          SetCaseMessageBoard: SZH.assets.api + '/Custom/SetCaseMessageBoard',
        },
        loadingFull:false,
        AccountId:'',
        ParentUserId:''
      }
    },
    methods: {
      sendMessage(){
        let self = this;
        if(!self.form.F_Message){
          self.$message.error('请输入留言内容！');
          return
        }
        self.loadingFull = true;
        self.$http.post(self.url.SetCaseMessageBoard,self.form)
          .then(result => {
            if (result.state == true) {
              self.$message.success('发送成功');
              self.getMessage()
            } else {
              self.$message.error(result.message)
            }
            self.loadingFull = false;
          }, () => {
            self.loadingFull = false;
            // 请求失败
            self.$message.error('请求失败，请检查您的网络是否可用。');
          });
      },
      reCall(item){
        let self = this;
        if(!item.F_ReMessage){
          self.$message.error('请输入留言内容！');
          return
        }
        self.loadingFull = true;
        self.$http.post(self.url.SetCaseMessageBoard,{
          F_CaseId:item.F_CaseId,
          F_ParentId:item.F_Id,
          F_Message:item.F_ReMessage,
          F_Type:1
        })
          .then(result => {
            if (result.state == true) {
              self.$message.success('恢复成功');
              self.getMessage()
            } else {
              self.$message.error(result.message)
            }
            self.loadingFull = false;
          }, () => {
            self.loadingFull = false;
            // 请求失败
            self.$message.error('请求失败，请检查您的网络是否可用。');
          });
      },
      toggleFun(item){
        item.F_Show = !item.F_Show
      },
      getMessage(){
        let self = this;
        self.loadingFull = true;
        self.$http.post(self.url.list,{
          keyValue:self.caseId
        })
          .then(result => {
            if (result.state == true && result.data && result.data.length>0) {
              result.data.forEach(item=>{
                item.F_Show = false;
                item.F_ReMessage = ''
              });
              self.messages = result.data;
            } else {
              self.messages = [];
            }
            self.loadingFull = false;
          }, () => {
            self.loadingFull = false;
            // 请求失败
            self.$message.error('请求失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},

    mounted() {
      this.ParentUserId = localStorage.getItem('pId');
      this.caseId = this.$route.query.caseId;
      this.AccountId = this.$route.query.accountId;
      this.form.F_CaseId = this.$route.query.caseId;
      this.getMessage();
    }
  }
</script>

<style scoped>
  .header {
    text-align: center;
    margin-bottom: 40px;
    padding: 20px;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .header h1 {
    font-size: 2.8rem;
    margin-bottom: 10px;
  }

  .header p {
    font-size: 1.2rem;
    opacity: 0.9;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    padding: 0px;
  }

  .new-message-section {
    flex: 1;
    min-width: 300px;
    background-color: white;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }

  .messages-section {
    flex: 2;
    min-width: 300px;
    background-color: white;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }

  .section-title {
    font-size: 1.1rem;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
    color: #2575fc;
    display: flex;
    align-items: center;
  }

  .section-title i {
    margin-right: 10px;
  }

  .form-group {
    margin-bottom: 20px;
    font-size: 14px;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #555;
  }

  input, textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    transition: border 0.3s;
  }

  input:focus, textarea:focus {
    border-color: #2575fc;
    outline: none;
  }

  textarea {
    min-height: 120px;
    resize: vertical;
  }

  .btn {
    background-color: #2575fc;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .btn:hover {
    background-color: #1a65e0;
  }

  .btn i {
    margin-right: 8px;
  }

  .btn-reply {
    background-color: #6a11cb;
    padding: 8px 15px;
    font-size: 0.9rem;
  }

  .btn-reply:hover {
    background-color: #5a0db3;
  }

  .message {
    border-left: 4px solid #2575fc;
    padding: 20px;
    margin-bottom: 25px;
    background-color: #f9fbfd;
    border-radius: 0 5px 5px 0;
    position: relative;
  }

  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .message-author {
    font-weight: bold;
    color: #2575fc;
    font-size: 1.1rem;
  }

  .message-time {
    color: #888;
    font-size: 0.9rem;
  }

  .message-content {
    margin-bottom: 15px;
    padding: 10px 0;
    font-size: 14px;
  }

  .replies {
    margin-top: 20px;
    padding-left: 20px;
    border-left: 2px dashed #ddd;
  }

  .reply {
    padding: 15px;
    margin-bottom: 15px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #eee;
  }
  .reply-content{
    font-size: 14px;
  }
  .reply-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .reply-author {
    font-weight: bold;
    color: #6a11cb;
    font-size: 14px;
  }

  .reply-time {
    color: #888;
    font-size: 12px;
  }

  .reply-form {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
  }

  .reply-form.active {
    display: block;
  }

  .reply-form .form-group {
    margin-bottom: 10px;
  }

  .no-messages {
    text-align: center;
    padding: 40px;
    color: #888;
  }

  .no-messages i {
    font-size: 3rem;
    margin-bottom: 15px;
    color: #ddd;
  }

  .message-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 15px;
  }

  .message-count {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f0f7ff;
    border-radius: 5px;
    font-size: 15px;
  }

  .message-count span {
    font-weight: bold;
    color: #2575fc;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/MessageBoard/MessageBoard.vue